import { t } from 'ttag'

import * as budgetActions from '../../actions/early/budget'
import * as earlyListingActions from '../../actions/early/earlyListing'
import * as h2Api from '../../h2Api'

const initialState = {
  jobZone: null,
  clusterId: null,
  roundId: 1,
  totalCredits: 100,
  creditsRemaining: 100,
  started: false,
  selections: [],
  completedAt: null,
  rounds: {
    1: {
      title: t`Housing`,
      description: t`Which of these houses would you want to live in? The bigger it is, the more it costs.`,
      choices: [
        {
          id: 1,
          img: 'apartment.svg',
          name: t`Small Apartment`,
          cost: 20
        },
        {
          id: 2,
          img: 'house.svg',
          name: t`House`,
          cost: 40
        },
        {
          id: 3,
          img: 'mansion.svg',
          name: t`Mansion`,
          cost: 70
        }
      ]
    },
    2: {
      title: t`Getting Around`,
      description: t`biking is hard work, but saves money. Cars are easier, but also expensive. How do you want to get around?`,
      choices: [
        {
          id: 4,
          img: 'walk.svg',
          name: t`Walk or Bike`,
          cost: 5
        },
        {
          id: 5,
          img: 'public.svg',
          name: t`Bus or Train`,
          cost: 15
        },
        {
          id: 6,
          img: 'drive.svg',
          name: t`Car`,
          cost: 30
        }
      ]
    },
    3: {
      title: t`Lifestyle`,
      description: t`what kinds of things do you like to do? Which picture below would be the most interesting for you?`,
      choices: [
        {
          id: 7,
          img: 'LifestyleLow.svg',
          name: t`Low Key`,
          cost: 10
        },
        {
          id: 8,
          img: 'LifestyleMedium.svg',
          name: t`Moderate`,
          cost: 20
        },
        {
          id: 9,
          img: 'LifestyleHigh.svg',
          name: t`Socialite`,
          cost: 50
        }
      ]
    },
    4: {
      title: t`Extra Savings`,
      description: t`the more you save, the more you have. Vacations, toys, and even emergencies cost money. How much will you save?`,
      choices: [
        {
          id: 10,
          img: 'SavingsLow.svg',
          name: t`Nothing`,
          cost: 0
        },
        {
          id: 11,
          img: 'SavingsMedium.svg',
          name: t`Just a little`,
          cost: 10
        },
        {
          id: 12,
          img: 'SavingsHigh.svg',
          name: t`A lot`,
          cost: 30
        }
      ]
    }
  }
}
const budget = (state = initialState, action) => {
  switch (action.type) {
    case earlyListingActions.LOAD_GAME:
      console.log(action.restCall.result)

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const selections = action.restCall.result.budget?.selections || {}

        return {
          ...state,
          ...action.restCall.result.budget,
          selections: Object.fromEntries(
            Object.keys(selections)?.map(sel => [
              sel,
              selections[sel].response ? selections[sel].response : selections[sel]
            ])
          )
        }
      }

      return state

    case budgetActions.SELECT_EDUCATION:
      return {
        ...state,
        jobZone: action.jobZone
      }
    case budgetActions.SELECT_CLUSTER:
      return {
        ...state,
        clusterId: action.clusterId
      }
    case budgetActions.SET_CREDIT_AMOUNT:
      if (state.started) {
        const diff = state.totalCredits - action.amount

        return {
          ...state,
          totalCredits: action.amount,
          creditsRemaining: state.creditsRemaining - diff
        }
      }

      return {
        ...state,
        started: true,
        totalCredits: action.amount,
        creditsRemaining: action.amount
      }
    case budgetActions.SELECT_ROUND:
      return {
        ...state,
        roundId: action.roundId
      }
    case budgetActions.SET_COMPLETED:
      return {
        ...state,
        completedAt: action.dateCompleted
      }
    case budgetActions.SELECT_OPTION:
      const pSelect = state.selections[action.round]
      let prevCost = 0

      if (pSelect) {
        const prevSelection = state.rounds[`${action.round}`].choices.find(
          r => r.id === pSelect
        )

        if (prevSelection) {
          prevCost = prevSelection.cost
        }
      }

      return {
        ...state,
        selections: {
          ...state.selections,
          [action.round]: action.choiceId
        },
        creditsRemaining: state.creditsRemaining - action.cost + prevCost
      }
    case budgetActions.UNSELECT_OPTION:
      return {
        ...state,
        selections: {
          ...state.selections,
          [action.round]: null
        },
        creditsRemaining: state.creditsRemaining + action.cost
      }
    case budgetActions.RESET_BUDGET:
      return initialState

    default:
      return state
  }
}

export default budget
